import React from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';

export const HookFormWrapper = ({ children, onSubmit, formData = {} }) => {
  const form = useForm(formData);

  return (
    <FormProvider {...form}>
      <form
        onSubmit={(e) => {
          e.stopPropagation();

          return form.handleSubmit(onSubmit)(e);
        }}
      >
        {children}
      </form>
    </FormProvider>
  );
};

HookFormWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formData: PropTypes.shape({})
};

export default HookFormWrapper;



// WEBPACK FOOTER //
// ./src/components/HookFormWrapper/HookFormWrapper.jsx